import { twMerge } from "tailwind-merge";

import { Paragraph } from "@fronterahealth/frontera-ui-components";

interface SegmentedTab<T extends string = string> {
  value: T;
  label: string;
}

interface SegmentedTabsProps<T extends string = string> {
  tabs: SegmentedTab<T>[];
  activeTab: T;
  onChange: (value: T) => void;
  className?: string;
}

export const SegmentedTabs = <T extends string>({ tabs, activeTab, onChange, className }: SegmentedTabsProps<T>) => {
  return (
    <div className={twMerge("bg-bg-pressed p-0.5 rounded-lg", className)}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.value;
        return (
          <button
            key={tab.value}
            className={twMerge("px-3 py-1.5 rounded-lg", isActive ? "bg-white" : "hover:bg-limestone-500")}
            onClick={() => onChange(tab.value)}
          >
            <Paragraph size="small" displayType="normal" colorType={isActive ? "primary" : "secondary"}>
              {tab.label}
            </Paragraph>
          </button>
        );
      })}
    </div>
  );
};
